//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  {clickToBack}  from '@/common/js/util'
import { mapGetters } from 'vuex'
	export default {
		data(){
			return {
				listShow: false,
				backHomeShow: true
			}
		},
		computed:{
			...mapGetters(['user'])
		},
		props:{
			title: {
				type: String,
				default: ''
			},
			position: {
				type: String,
				default: 'relative'
			},
			isWhite: {
				type: Boolean,
				default: false
			},
			borderBottom:{
				type: Boolean,
				default: false
			},
			rightShow:{
				type: Boolean,
				default: true
			},
			styleObject: {
				type: Object,
				default: function(){
					return {};
				}
			}
		},
		mounted(){
			//console.log(this.user);
			if(this.user&&this.user.origin){
				this.backHomeShow = false
			}else{
				this.backHomeShow = this.rightShow
			}

      if(window.__wxjs_environment == 'miniprogram'){
        document.title = this.title
        this.backHomeShow = false
      }
		},
		methods: {
			clickBack(){
        let _this = this;
      	try {
          if (/android/i.test(window.navigator.userAgent)) {
            AppUtil.redirect("historyback");
          } else if (/iphone/i.test(window.navigator.userAgent)) {
            window.webkit.messageHandlers.redirect.postMessage({
              type: "historyback"
            });
          }
          _this.unihistoryback()
        } catch (e) {
          _this.$router.go(-1);
          _this.unihistoryback()
        }
				//clickToBack(this)
				// window.history.length >= 2
        // ? this.$router.go(-1)
        // : this.$router.push('/')				
			},
			clickList(){
				this.listShow = !this.listShow
			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/headerBack.vue